import { Route } from '@/typings/router';

/*
 * Note:
 * Menu items with children need to set a key starting with "/"
 * @see https://github.com/umijs/route-utils/blob/master/src/transformRoute/transformRoute.ts#L219
 */

export const menuAsesor: Route[] = [
  {
    path: '/Estancias',
    name: 'Inicio',
    icon: 'home',
  },
];
